import {
    ACTIVITY_DRAWER_MAX_WIDTH_PX,
    ACTIVITY_DRAWER_MIN_WIDTH_PX,
    ACTIVITY_DRAWER_WIDTH_PX,
} from "../Constants/activityPanelPinned.js";
import {
    TEAM_PEOPLE_PANEL_DEFAULT_WIDTH_PX,
    TEAM_PEOPLE_PANEL_MAX_WIDTH_PX,
    TEAM_PEOPLE_PANEL_MIN_WIDTH_PX,
} from "./teamPeoplePanelResize.js";

/**
 * @param {number|null|undefined} widthPx
 * @returns {number}
 */
export function clampActivityDrawerWidthPx(widthPx) {
    if (widthPx == null || Number.isNaN(Number(widthPx))) {
        return ACTIVITY_DRAWER_WIDTH_PX;
    }

    const rounded = Math.round(Number(widthPx));

    return Math.min(
        ACTIVITY_DRAWER_MAX_WIDTH_PX,
        Math.max(ACTIVITY_DRAWER_MIN_WIDTH_PX, rounded),
    );
}

/**
 * @param {number|null|undefined} widthPx
 * @returns {number|null}
 */
export function clampTeamPeoplePanelWidthPx(widthPx) {
    if (widthPx == null || Number.isNaN(Number(widthPx))) {
        return null;
    }

    const rounded = Math.round(Number(widthPx));

    return Math.min(
        TEAM_PEOPLE_PANEL_MAX_WIDTH_PX,
        Math.max(TEAM_PEOPLE_PANEL_MIN_WIDTH_PX, rounded),
    );
}

/**
 * @param {number|null|undefined} widthPx
 * @returns {number}
 */
export function resolveTeamPeoplePanelWidthPx(widthPx) {
    return (
        clampTeamPeoplePanelWidthPx(widthPx) ??
        TEAM_PEOPLE_PANEL_DEFAULT_WIDTH_PX
    );
}
